import type { ReactNode } from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';
import type { HeaderVariation } from '@repo/ui/src/types/headerVariation';

interface HeaderVarietyProps {
  children: ReactNode;
  className?: string;
  /** @deprecated Use className instead */
  classNames?: string;
  defaultVariation?: 'h1' | 'h2' | 'h3';
  headerVariation?: HeaderVariation | '';
}

const HeaderVariety = (props: HeaderVarietyProps) => {
  const { children, className, defaultVariation, headerVariation = '' } = props;
  return (
    <>
      {headerVariation === 'h1' || (defaultVariation === 'h1' && headerVariation === '') ? (
        <h1 className={classNames('tra-text-web-heading-1', className)}>{children}</h1>
      ) : headerVariation === 'h2' || (defaultVariation === 'h2' && headerVariation === '') ? (
        <h2 className={classNames('md:tra-text-web-heading-2', className)}>{children}</h2>
      ) : (
        <h3 className={classNames('tra-text-web-heading-3', className)}>{children}</h3>
      )}
    </>
  );
};

export default HeaderVariety;
